import React from 'react'
import Spinner from '../components/Spinners/Spinner'

const Loader = ({ size = 4 }) => {
  return <Spinner color="danger" style={{ width: `${size}rem`, height: `${size}rem` }} />
}

export default Loader
